// extracted by mini-css-extract-plugin
export default {"eachFaqWrapper":"InPageFAQCard_eachFaqWrapper__gpk5w","efHeader":"InPageFAQCard_efHeader__sVI8o","efContent":"InPageFAQCard_efContent__uJGEk"};